import differenceInHoursDateUtil from 'utils/date/difference-in-hours'
import getItemLocalStorageUtil from 'utils/local-storage/get-item'
import { LOYALTY_FAST_TRACK_EXPIRY_LOCAL_STORAGE_KEY } from 'containers/LoyaltyFastTrackExpiry/constants'
import removeLocalStorageKeysLoyaltyFastTrackUtil from 'containers/LoyaltyFastTrackExpiry/utils/remove-local-storage-keys'

const DIFF_IN_HOURS = 1

/**
 * @param isModal
 * @return {boolean}
 */
export default function shouldShowModalOrBannerExpiringLoyaltyFastTrackUtil ({
  isModal
} = {}) {
  const key = isModal
    ? LOYALTY_FAST_TRACK_EXPIRY_LOCAL_STORAGE_KEY.MODAL_CLOSED_AT
    : LOYALTY_FAST_TRACK_EXPIRY_LOCAL_STORAGE_KEY.BANNER_CLOSED_AT
  const modalClosedAtStr = getItemLocalStorageUtil(key)

  let shouldShowModal = true
  let modalClosedAt

  if (modalClosedAtStr) {
    modalClosedAt = new Date(modalClosedAtStr)
  }

  if (modalClosedAt) {
    shouldShowModal = differenceInHoursDateUtil(
      new Date(),
      new Date(modalClosedAt)
    ) >= DIFF_IN_HOURS
  }

  if (
    modalClosedAt &&
    shouldShowModal
  ) {
    removeLocalStorageKeysLoyaltyFastTrackUtil()
  }

  return shouldShowModal
}
